import { render, staticRenderFns } from "./RoutingMTK.vue?vue&type=template&id=d275ac14&scoped=true"
import script from "./RoutingMTK.vue?vue&type=script&lang=js"
export * from "./RoutingMTK.vue?vue&type=script&lang=js"
import style0 from "./RoutingMTK.vue?vue&type=style&index=0&id=d275ac14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d275ac14",
  null
  
)

export default component.exports